import { createSlice } from '@reduxjs/toolkit';

import { clearCombinedToken as clearAccessToken } from './sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { clearEntitlements } from './sessionStorageHelpers/entitlementsHelper/entitlementsHelper';

export const resetStoreSlice = createSlice({
    name: 'store',
    initialState: {},
    reducers: {
        reset: () => {
            clearAccessToken();
            clearEntitlements();
            // in rootReducer, we can use it to CLEAR the complete Redux Store's state
        },
    },
});

export const { reset } = resetStoreSlice.actions;
